import React, { useState } from "react";
import DropDownButtonStyle from "../../../../assets/css/components/admin/products/DropDownButton.css.js";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faFilter } from "@fortawesome/free-solid-svg-icons";

export default function DropDownButtonOptionsFilter(props) {
  const [openDropContent, setOpenDropContent] = useState(false);

  /**
   * Update the filters
   * @param {Event} e The event
   * @param {Object} data The new filter data
   */
  const updateFilters = (e, data) => {
    e.preventDefault();
    // Check if we are toggling off an active filter
    let newData = { ...data };
    const key = Object.keys(data)[0];
    const value = data[key];

    // If the filter is already active with the same value, toggle it off (clear it)
    if (props[key] === value) {
        // Use null for boolean filters, empty string for string filters
        const isBooleanFilter = typeof value === 'boolean';
        newData[key] = isBooleanFilter ? null : "";
    }

    props.updateFilters(newData);
  }

  const changeStatusDorpFocus = (e) => {
    e.preventDefault();
    setOpenDropContent(!openDropContent);
  };
  
  const changeStatusDorpBlur = (e) => {
    if (!e.currentTarget.contains(e.relatedTarget)) {
        setOpenDropContent(false);
    }
  };

  // Helper to render filter option
  const renderOption = (label, filterKey, filterValue) => {
    const isSelected = props[filterKey] === filterValue;
    
    return (
      <div
        className={`items item ${isSelected ? "selected" : ""}`}
        onMouseDown={(e) => updateFilters(e, { [filterKey]: filterValue })}
        key={`${filterKey}-${filterValue}`}
      >
        <p>{label}</p>
        
        {/* Only CSS styles on this span now, no icon inside */}
        <span className={`icon-active ${isSelected ? "open" : ""}`}></span>
      </div>
    );
  };

  return (
    <DropDownButtonStyle>
      <button
        className={`DropBtn ${openDropContent ? "open" : ""}`}
        onClick={changeStatusDorpFocus}
        onBlur={changeStatusDorpBlur}
      >
        <div className="content-text-icon">
          <div className="content-text">
            <p>Filtrar por</p>
          </div>
          <div className="content-icon">
            <span className="icon">
               <FontAwesomeIcon icon={faFilter} />
            </span>
          </div>
        </div>
        
        <div className={`optionsDrop ${openDropContent ? "open" : ""}`}>
          {/* Linked Status */}
          {renderOption("Sincronizados", "filterLinkedTo", "linked")}
          {renderOption("No Sincronizados", "filterLinkedTo", "unlinked")}
          
          {/* Price Filters */}
          {renderOption("Precio = 0", "filterPrice", "=0")}
          {renderOption("Precio > 0", "filterPrice", ">0")}
          
          {/* Stock Filters */}
          {renderOption("Sin Stock (0)", "filterStock", "=0")}
          {renderOption("Con Stock (>0)", "filterStock", ">0")}
          
          {/* Plugin specific filters */}
          {props.currentPlugin === "ml" && (
            <>
              {renderOption("Publicados", "onCbtMarketplaces", true)}
              {renderOption("No Publicados", "onCbtMarketplaces", false)}
            </>
          )}

          {props.currentPlugin === "odoo" && (
            <>
              {renderOption("Con Empresa", "filterWithCompany", true)}
              {renderOption("Sin Empresa", "filterWithCompany", false)}
              {renderOption("Con Impuestos", "filterWithTaxes", true)}
              {renderOption("Sin Impuestos", "filterWithTaxes", false)}
            </>
          )}
        </div>
      </button>
    </DropDownButtonStyle>
  );
}
